
export const useAppHooks = () => {
  console.log("use app hooks")
};
